goog.provide("shadow.js.shim.module$src$svg$inform$check_circle_fill_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$check_circle_fill_svg");
shadow.js.shim.module$src$svg$inform$check_circle_fill_svg = shadow.js.nativeProvides["src/svg/inform/check-circle-fill.svg"] = shadow$bridge("src/svg/inform/check-circle-fill.svg");
module$shadow_js_shim_module$src$svg$inform$check_circle_fill_svg.default = shadow.js.shim.module$src$svg$inform$check_circle_fill_svg;
